export default {
    // baseApi:"http://192.168.0.239:8081",
    baseApi:common.baseApi,
    //baseApi:"http://localhost:9002",
    casAddress:"http://zwfw.xa.gov.cn/zdpyc/sso/",//2022-09-30废弃
    ssoLogin:"https://sfrz.shaanxi.gov.cn",
    client_id:"XM1QXCAWUFLTCH",
    clientSecret:"RGHAETCI2I9ZCEN849U9",
    webApi:common.webApi,
    newApi:common.newApi,
    version:"/api/v1",
    noJSONstrUrl:["/upload","/getUserInfo"],
    projectKey:"西安12345网站",
    //解决问题 id
    dictId:1213
    // baseApi:"http://121.37.158.191:9002",
    // // baseApi:"http://192.168.0.112:9002",
    // casAddress:"http://zwfw.xa.gov.cn/zdpyc/sso/",
    // webApi:"http://121.37.158.191:8081",
    // // webApi:"http://192.168.0.190:8081",
    // version:"/api/v1",
    // noJSONstrUrl:["/upload"],
    // projectKey:"西安12345网站",
    // //解决问题 id
    // dictId:1213
}
/**
 * baseApi：单点登陆 客户端地址
 * casAddress：总门户生产环境cas地址
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
